(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/frame-blur/assets/javascripts/use-is-at-frame-position.js') >= 0) return;  svs.modules.push('/components/tipsen/frame-blur/assets/javascripts/use-is-at-frame-position.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
const framePosition = svs.components.tipsen.frameBlur.constants.framePosition;
const positionValidation = (_scrollElement, _position) => {
  if (_position === framePosition.START && _scrollElement.scrollLeft === 0) {
    return true;
  } else if (_position === framePosition.END && _scrollElement.scrollLeft === _scrollElement.scrollWidth - _scrollElement.offsetWidth) {
    return true;
  }
  return false;
};
const useIsAtFramePosition = (scrollElement, position) => {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAtPosition = _useState2[0],
    setIsAtPosition = _useState2[1];
  useEffect(() => {
    const onScrollRef = () => {
      window.requestAnimationFrame(() => {
        setIsAtPosition(positionValidation(scrollElement, position));
      });
    };
    if (scrollElement) {
      setIsAtPosition(positionValidation(scrollElement, position));
      scrollElement.addEventListener('scroll', onScrollRef);
    }
    return () => {
      if (scrollElement) {
        scrollElement.removeEventListener('scroll', onScrollRef);
      }
    };
  }, [scrollElement, position]);
  return isAtPosition;
};
setGlobal('svs.components.tipsen.frameBlur.useIsAtFramePosition', useIsAtFramePosition);

 })(window);